import { Box } from '@material-ui/core';
import ProductItem from './item';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import theme from '../theme';
import urlNormalizer from 'tools/urlNormalization';
import { useRouter } from 'next/router';
import { elevateClickNotification } from 'tools/elevateClient';
import { makeStyles } from '@material-ui/styles';
import {
    getDeliveryTimeId,
    getFastDelivery,
    getMainVariant,
    getMarketingLabel,
    getPreferImageType,
    getProductVariants,
    getStock,
    getUUID,
    preventFloatRoundingIssues,
} from '@functions/elevateOps';
import ProductThumbnail from '@components/products/thumbnail';

const useStyles = makeStyles(() => ({
    productGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gridTemplateColumns: 'repeat(2, minmax(0, 50%))',
        gap: 4,
        [theme.breakpoints.up('sm')]: {
            gridTemplateColumns: 'repeat(3, minmax(0, 33.333%))',
            gap: 4,
        },
        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'repeat(4, minmax(0, 25%))',
            gap: 4,
        },
    },
    productItem: {
        maxWidth: 'none',
    },
    productImage: {
        flexGrow: 1,
        backgroundColor: theme.palette.primary.background,
        '& img': {
            transition: 'opacity 0.25s ease',
        },
        '&:hover img': {
            opacity: 0.9,
        },
    },
    noHitItem: {
        gridColumn: '1/5',
    },
    alertMessage: {
        textAlign: 'center',
    },
    alert: {
        justifyContent: 'center',
        textAlign: 'center',
    },
}), { name: 'RelevateProductGrid' });

function RelevateProductGrid({ products, paramsHash, imageType }) {
    const router = useRouter();
    const classes = useStyles();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    async function onClick(product) {
        await elevateClickNotification(
            product.ticket,
            isMobile ? 'mobile' : 'desktop',
        );
    }

    function renderProducts(product, key) {
        let mainVariant = getMainVariant(product);
        let productImageType = getPreferImageType(mainVariant);

        if (!imageType) {
            imageType = productImageType;
        }

        return <ProductItem
            id={getUUID(mainVariant)}
            productNumber={mainVariant.key}
            propertyIds={[ ...getMarketingLabel(mainVariant) ]}
            deliveryTimeString={getDeliveryTimeId(mainVariant)}
            name={product.title}
            manufacturer={product.brand}
            link={urlNormalizer(product.link, router.basePath)}
            prices={{
                price: mainVariant.sellingPrice,
                listPrice: mainVariant.listPrice,
                isOnSale: mainVariant.sellingPrice < mainVariant.listPrice,
                discount: mainVariant.sellingPrice < mainVariant.listPrice ? {
                    amount: mainVariant.sellingPrice - mainVariant.listPrice,
                    percentage: preventFloatRoundingIssues(mainVariant.sellingPrice, mainVariant.listPrice),
                } : undefined,
            }}
            image={<ProductThumbnail
                alt={mainVariant.name}
                imageType={imageType}
                product={{ id: getUUID(mainVariant) }}
            />}
            list={{ id: '', name: 'search_results', location: router.asPath }}
            variants={getProductVariants(product) ? mainVariant.label : false}
            stock={getStock(mainVariant)}
            fastDelivery={getFastDelivery(mainVariant)}
            available={mainVariant.inStock}
            addToCart={'minimal'}
            isOutlet={product.title.indexOf('OUTLET') >= 0}
            position={key + 1}
            clickCallback={onClick.bind(this, product)}
            elevateTicket={mainVariant.ticket}
            isMobile={isMobile}
            streamIds={product?.streamIds || []}
            customClasses={{ item: classes.productItem }}
            lazyHydrate={false}
            key={paramsHash + key}
        />;
    }

    return (
        <Box component="div" className={[ classes.productGrid, 'product-grid' ].join(' ')} style={{ display: 'grid' }}>
            {products.length > 0 &&
                products.map((product, key) => renderProducts(product, key))
            }
        </Box>
    );
}

export default RelevateProductGrid;
